import { graphql } from "@opensea/graphql"

export const getCollectionSweepQuoteErrorFragment = graphql(`
  fragment getCollectionSweepQuoteError on CollectionSweepQuote {
    __typename
  }
`)
